module.exports = __webpack_public_path__ + "img/page6_cumulative_bac.63b6d729.png";